export const calculateTime = (totalSeconds = 0) => {
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    let seconds = Math.round(totalSeconds % 60);

    minutes = String(minutes).padStart(2, "0");
    seconds = String(seconds).padStart(2, "0");
    hours = String(hours).padStart(2, "0");
    if (hours.toString() === '00') {
        return `${minutes}:${seconds}`;
    }
    else {
        return `${hours}:${minutes}:${seconds}`;
    }
}

export const formatTranscriptMessages = messages => {
    return messages.map(({from, text, timeOffset, startTime, endTime, id}) => {
        return {
            name: from?.name,
            text: text,
            timeOffsetToShow: calculateTime(timeOffset),
            timeOffset: timeOffset,
            startTime,
            endTime,
            id,
            from
        }
    });
}